import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";

const getAllProductErrors = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_ERRORS +
      queryParams,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const updateProductErrorVariant = (id, variantPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_ERRORS +
      `/${id}/variant`,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(variantPayload)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const applyToAllVariants = (id, payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_ERRORS +
      `/${id}/apply-all-variants`,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(payload)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getProductErrorById = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_ERRORS +
      `/${id}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const productErrorApiService = {
  getAllProductErrors,
  updateProductErrorVariant,
  getProductErrorById,
  applyToAllVariants,
};
